import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Menu,
  X,
  Home,
  Mountain,
  Heart,
  Users,
  Map,
  AlertTriangle,
  type LucideIcon,
} from 'lucide-react';

type NavItem = {
  name: string;
  href: string;
  icon: LucideIcon;
};

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navigation: NavItem[] = [
    { name: 'Home', href: '/', icon: Home },
    { name: 'BikePark', href: '/bikepark', icon: Mountain },
    { name: 'Donații', href: '/donatii', icon: Heart },
    { name: 'Team', href: '/team', icon: Users },
    // { name: 'Potecarul', href: '/potecarul', icon: BookOpen },
    { name: 'Hartă', href: '/harta', icon: Map },
    { name: 'Raportează', href: '/report', icon: AlertTriangle },
  ];

  const navLinkClass = (href: string, mobile = false) => {
    const isActive = location.pathname === href;

    if (mobile) {
      return `${
        isActive
          ? 'bg-orange-50 text-orange-500'
          : 'text-gray-700 hover:bg-gray-50 hover:text-orange-500'
      } group flex items-center gap-2 px-3 py-2 rounded-md text-base font-medium transition-colors duration-200`;
    }

    return `${
      isActive ? 'text-orange-500' : 'text-gray-700 hover:text-orange-500'
    } group flex items-center gap-2 transition-colors duration-200`;
  };

  const iconClass = (href: string) => {
    const isActive = location.pathname === href;
    return `w-4 h-4 shrink-0 transition-all duration-200 group-hover:scale-110 group-hover:-translate-y-px ${
      isActive ? 'scale-105' : ''
    }`;
  };

  return (
    <nav className="relative z-50 bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-16">
          <div className="flex">
            <Link to="/" className="flex items-center group">
              <span className="text-2xl font-bold text-orange-500 transition-transform duration-200 group-hover:scale-105">
                NHVelo
              </span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={navLinkClass(item.href)}
              >
                <item.icon className={iconClass(item.href)} />
                {item.name}
              </Link>
            ))}
          </div>

          {/* Mobile Navigation Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 hover:text-orange-500 transition-colors duration-200"
              aria-label={isOpen ? 'Închide meniul' : 'Deschide meniul'}
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isOpen && (
          <div className="md:hidden">
            <div className="pt-2 pb-3 space-y-1">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={navLinkClass(item.href, true)}
                  onClick={() => setIsOpen(false)}
                >
                  <item.icon className={iconClass(item.href)} />
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}